import Joi from "joi";
export const addShipmentSchema = (lang) => {
    const language = lang === "AR" ? "arabic" : "english";
    const joiMessage = require(`../../translate/${language}/joi.json`);

    const schema = {
        // shipping_id: Joi.number().positive().required().messages({
        //     "number.base": joiMessage.shipment_modal.shipping_id.invalid,
        //     "any.empty": joiMessage.shipment_modal.shipping_id.required,
        //     "number.positive": joiMessage.shipment_modal.shippingCost_cubic_per_meter.positive
        // }),
        totalCBM: Joi.number().positive().allow(0).required().messages({
            "number.base": joiMessage.shipment_modal.totalCBM.invalid,
            "number.positive": joiMessage.shipment_modal.totalCBM.positive,
            "any.required": joiMessage.shipment_modal.totalCBM.required
        }),
        shippingFees: Joi.number().positive().allow(0).optional().messages({
            "number.base": joiMessage.shipment_modal.shippingFees.invalid,
            "number.positive": joiMessage.shipment_modal.shippingFees.positive,
        }),
        shippingCost_cubic_per_meter: Joi.number().positive().allow(0).required().messages({
            "number.base": joiMessage.shipment_modal.shippingCost_cubic_per_meter.invalid,
            "number.positive": joiMessage.shipment_modal.shippingCost_cubic_per_meter.positive,
            "any.required": joiMessage.shipment_modal.shippingCost_cubic_per_meter.required
        }),
        NB: Joi.string().allow("").optional().max(254).messages({
            "string.base": joiMessage.shipment_modal.NB.invalid,
            "string.max": joiMessage.shipment_modal.NB.max,
        }),
        totalBoxs: Joi.number().allow(0).positive().optional().messages({
            "number.base": joiMessage.shipment_modal.totalBoxs.invalid,
            "number.positive": joiMessage.shipment_modal.totalBoxs.positive
        }),
        totalPeices: Joi.number().allow(0, null).integer().optional().messages({
            "number.base": joiMessage.shipment_modal.totalPeices.invalid,
            "number.integer": joiMessage.shipment_modal.totalPeices.positive
        }),
        containerNumber: Joi.string().allow("").optional().min(1).max(100).messages({
            "string.base": "رقم الحاوية: " + "غير صالح",
            "string.min": "رقم الحاوية: " + "على الاقل حرف واحد",
            "string.max": "رقم الحاوية: " + "اطول من الازم"
        }),
        trackingId: Joi.string().allow("").optional().min(1).max(40).messages({
            "string.base": "رقم التتبع: " + "غير صالح",
            "string.min": "رقم التتبع: " + "على الاقل حرف واحد",
            "string.max": "رقم التتبع: " + "على الاكثر 40 حرف"
        }),
        recordDate: Joi.date().required().messages({
            "date.base": joiMessage.exports_tab.add_record.recordDate.required,
            "string.invalid": joiMessage.exports_tab.add_record.recordDate.invalid
        }),
        exchangeRateRMB: Joi.number().required().allow(0).messages({
            "number.base": joiMessage.exports_tab.add_record.exchangeRateRMB.invalid,
            "number.empty": joiMessage.exports_tab.add_record.exchangeRateRMB.required,
        })
    };
    return schema;
};

export const editShipmentSchema = (lang) => {
    const language = lang === "AR" ? "arabic" : "english";
    const joiMessage = require(`../../translate/${language}/joi.json`);
    const schema = {
        shipping_id: Joi.number().positive().optional().messages({
            "number.base": joiMessage.shipment_modal.shipping_id.invalid,
            "any.empty": joiMessage.shipment_modal.shipping_id.required,
            "number.positive": joiMessage.shipment_modal.shippingCost_cubic_per_meter.positive
        }),
        totalCBM: Joi.number().positive().allow(0).optional().messages({
            "number.base": joiMessage.shipment_modal.totalCBM.invalid,
            "number.positive": joiMessage.shipment_modal.totalCBM.positive,
            "any.required": joiMessage.shipment_modal.totalCBM.required
        }),
        shippingFees: Joi.number().positive().allow(0).optional().messages({
            "number.base": joiMessage.shipment_modal.shippingFees.invalid,
            "number.positive": joiMessage.shipment_modal.shippingFees.positive,
        }),
        shippingCost_cubic_per_meter: Joi.number().positive().allow(0).optional().messages({
            "number.base": joiMessage.shipment_modal.shippingCost_cubic_per_meter.invalid,
            "number.positive": joiMessage.shipment_modal.shippingCost_cubic_per_meter.positive,
            "any.required": joiMessage.shipment_modal.shippingCost_cubic_per_meter.required
        }),
        NB: Joi.string().allow("").optional().max(254).messages({
            "string.base": joiMessage.shipment_modal.NB.invalid,
            "string.max": joiMessage.shipment_modal.NB.max,
        }),
        totalBoxs: Joi.number().allow(0).positive().optional().messages({
            "number.base": joiMessage.shipment_modal.totalBoxs.invalid,
            "number.positive": joiMessage.shipment_modal.totalBoxs.positive
        }),
        totalPeices: Joi.number().allow(0).integer().optional().messages({
            "number.base": joiMessage.shipment_modal.totalPeices.invalid,
            "number.integer": joiMessage.shipment_modal.totalPeices.positive
        }),
        containerNumber: Joi.string().allow("").optional().min(1).max(100).messages({
            "string.base": "رقم الحاوية: " + "غير صالح",
            "string.min": "رقم الحاوية: " + "على الاقل حرف واحد",
            "string.max": "رقم الحاوية: " + "اطول من الازم"
        }),
        trackingId: Joi.string().allow("").optional().min(1).max(40).messages({
            "string.base": "رقم التتبع: " + "غير صالح",
            "string.min": "رقم التتبع: " + "على الاقل حرف واحد",
            "string.max": "رقم التتبع: " + "على الاكثر 40 حرف"
        }),
        recordDate: Joi.date().optional().messages({
            "date.base": joiMessage.exports_tab.add_record.recordDate.required,
            "string.invalid": joiMessage.exports_tab.add_record.recordDate.invalid
        }),
        exchangeRateRMB: Joi.number().optional().allow(0).messages({
            "number.base": joiMessage.exports_tab.add_record.exchangeRateRMB.invalid,
            "number.empty": joiMessage.exports_tab.add_record.exchangeRateRMB.required,
        })
    };
    return schema;
}

export const payRecordSchema = (lang) => {
    const language = lang === "AR" ? "arabic" : "english";
    const joiMessage = require(`../../translate/${language}/joi.json`);

    const schema = {
        initialData: {
            invoiceAmount: null,
            exchangeRateRMB: null,
            recordDate: null,
            NB: null
        },
        schema: Joi.object({
            invoiceAmount: Joi.number().positive().allow(0).required().messages({
                "number.empty": joiMessage.common.required,
                "number.base":
                    joiMessage.exports_tab.pay_record.invoiceAmount.positve_number,
                "number.positive":
                    joiMessage.exports_tab.pay_record.invoiceAmount.positve_number,
            }),
            exchangeRateRMB: Joi.number().positive().required().allow(0).messages({
                "number.base": joiMessage.exports_tab.add_record.exchangeRateRMB.invalid,
                "number.empty": joiMessage.exports_tab.add_record.exchangeRateRMB.required,
                "number.positive":
                    joiMessage.exports_tab.pay_record.invoiceAmount.positve_number,
            }),
            recordDate: Joi.date().required().messages({
                "date.base": joiMessage.exports_tab.add_record.recordDate.required,
                "string.invalid": joiMessage.exports_tab.add_record.recordDate.invalid
            }),
            NB: Joi.string().allow(null, "").optional().min(1).max(254).messages({
                "string.base": joiMessage.exports_tab.add_record.notes.invalid,
                "string.min": joiMessage.exports_tab.add_record.notes.min,
                "string.max": joiMessage.exports_tab.add_record.notes.max,
            })
        }),
        explicitCheck: {
            invoiceAmount: false,
            exchangeRateRMB: false,
            recordDate: false,
            NB: false
        },
        validationOptions: {
            abortEarly: true,
        },
    };
    return { schema: schema };
};